import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type userPreviewPanelQuery,
} from './__generated__/userPreviewPanelQuery.graphql';
import type { UserPreviewPanelProps } from './types';

type EntryPointParams = { cloudId: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';

const userPreviewPanelEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			queryReference: userPreviewPanelQuery;
		},
		Record<string, never>,
		UserPreviewPanelProps,
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/UserPreviewPanel" */ './index'
			),
		{
			moduleId: 'user-preview-panel-entrypoint',
		},
	),
	getPreloadProps: ({ cloudId }: EntryPointParams) => ({
		queries: {
			queryReference: {
				parameters,
				variables: {
					cloudId,
				},
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});

export default userPreviewPanelEntryPoint;
